import options from './differentialPressure.component';


export default {
    selector: "dtEmulatorDifferentialPressure",
    options
}
